import { FilterOperator } from "./FilterOperator";

export const buildMultipleFilterValues = <T extends string = string>(
  values: T | T[],
  operator: FilterOperator,
) => (Array.isArray(values) ? values.join(` ${operator} `) : values);
